export default "__VITE_ASSET__WoP78aV7__"